import moment from 'moment'
import { useEffect, useState } from 'react'

import { type ICommonField } from '@/app/types/common'
import { type IConpanyContract } from '@/app/types/dmsTypes'

import { emptyContract, type InputEvent } from '../../../helper'

interface IParams {
    data?: IConpanyContract
}

export const useFields = (params: IParams) => {
    const { data } = params
    const _data: IConpanyContract = data || emptyContract

    const initialName: ICommonField = {
        name: 'Наименование договора',
        value: _data.name,
        error: null,
        isTouched: false,
        placeholder: 'Наименование договора'
    }

    const initialConclusionAt: ICommonField = {
        name: 'Дата начала',
        value: _data.conclusionAt ? moment(_data.conclusionAt).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
        error: null,
        isTouched: false,
        placeholder: 'Дата начала'
    }

    const initialFinishedAt: ICommonField = {
        name: 'Дата окончания',
        value: _data.finishedAt ? moment(_data.finishedAt).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
        error: null,
        isTouched: false,
        placeholder: 'Дата окончания'
    }

    const initialUpdateAt: ICommonField = {
        name: 'Дата последнего изменения',
        value: _data.updateAt ? moment(_data.updateAt).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
        error: null,
        isTouched: false,
        placeholder: 'Дата последнего изменения'
    }

    const [name, setName] = useState<ICommonField>(initialName)
    const [conclusionAt, setConclusionAt] = useState<ICommonField>(initialConclusionAt)
    const [finishedAt, setFinishedAt] = useState<ICommonField>(initialFinishedAt)

    const onChangeName = (e: InputEvent) => setName((prev) => ({ ...prev, value: e.target.value }))
    const onChangeConclusionAt = (e: moment.Moment) =>
        setConclusionAt((prev) => ({ ...prev, value: moment(e).format('YYYY-MM-DDT00:00:00.000') }))
    const onChangeFinishedAt = (e: moment.Moment) =>
        setFinishedAt((prev) => ({ ...prev, value: moment(e).format('YYYY-MM-DDT23:59:59.000') }))
    const onSetIsTouchedName = () => setName((prev) => ({ ...prev, isTouched: true }))
    const onSetIsTouchedConclusionAt = () => setConclusionAt((prev) => ({ ...prev, isTouched: true }))
    const onSetIsTouchedFinishedAt = () => setFinishedAt((prev) => ({ ...prev, isTouched: true }))

    useEffect(() => {
        if (!name.value) {
            setName((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else {
            setName((prev) => ({ ...prev, error: null }))
        }

        if (!conclusionAt.value) {
            setConclusionAt((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else {
            setConclusionAt((prev) => ({ ...prev, error: null }))
        }
    }, [name.value, setName, conclusionAt.value, setConclusionAt])

    const onCheckIsToched = (): boolean => {
        if (name.isTouched || conclusionAt.isTouched) {
            return true
        }
        return false
    }

    const onSetTouchAll = () => {
        onSetIsTouchedName()
        onSetIsTouchedConclusionAt()
        onSetIsTouchedFinishedAt()
    }

    return {
        name,
        onChangeName,
        onSetIsTouchedName,
        //
        conclusionAt,
        onChangeConclusionAt,
        onSetIsTouchedConclusionAt,
        //
        finishedAt,
        onChangeFinishedAt,
        onSetIsTouchedFinishedAt,
        //
        updateAt: initialUpdateAt,
        //
        isSomeToched: onCheckIsToched(),
        onSetTouchAll
    }
}
